import styles from "./location.module.scss"
import { AppContext } from "../../../../utils/context"
import { useContext } from "react"
// import { printTranslation } from "../../../../utils/translations"

// Import the track maps
import { Tracks } from "./tracks"

import { CosmosText, CosmosTitle } from "@cosmos/web-react"

// Returns the HTML markup for the location slide
export default function Location() {
	// Pull the active event from the context
	const { event, lang } = useContext(AppContext)

	// Returns early if the event is not available
	if (!event) return null

	// Pull the longitude and latitude from the event
	const { country_name, track_name, track_laps, track_lap_distance, track_record_year, track_record_time, track_race_distance, track_first_gp, track_record_driver } = event

	// get the track record driver as C. Lastname e.g. Max Verstappen -> M. VERSTAPPEN
	const trackRecordDriverFormatted = track_record_driver
		?.split(" ")
		?.map((name, index) => (index === 0 ? name.charAt(0).toUpperCase() + "." : name.toUpperCase()))
		?.join(" ")
	return (
		// <>
		<div className={styles.container}>
			<CosmosTitle
				size="xx-large"
				className={styles.title}>
				{/* {printTranslation(`${event?.event_key}_CountryName`, lang, country_name.toUpperCase())} */}
				{country_name.toUpperCase()}
			</CosmosTitle>

			<div className={styles.row}>
				<div className={styles.track}>
					<img
						src={Tracks[event?.track_name]}
						alt={track_name}
					/>
				</div>

				<div className={styles.statsModal}>
					<CosmosText
						className={styles.trackStats}
						size="large"
						weight="bold">
						{/* {printTranslation(`${event?.event_key}_TrackName`, lang, `${track_name} Stats`)}{" "} */}
						{track_name} Stats
					</CosmosText>
					<div className={styles.stats}>
						<div className={styles.stat}>
							<div className={styles.statLabel}>
								<CosmosText
									size="x-small"
									weight="bold">
									First Grand Prix
								</CosmosText>
							</div>
							<div className={styles.statValue}>
								<CosmosText
									weight="bold"
									size="x-small">
									{track_first_gp}
								</CosmosText>
							</div>
						</div>

						<div className={styles.stat}>
							<div className={styles.statLabel}>
								<CosmosText
									size="x-small"
									weight="bold">
									Total Laps
								</CosmosText>
							</div>
							<div className={styles.statValue}>
								<CosmosText
									weight="bold"
									size="x-small">
									{track_laps}
								</CosmosText>
							</div>
						</div>

						<div className={styles.stat}>
							<div className={styles.statLabel}>
								<CosmosText
									size="x-small"
									weight="bold">
									Race Distance
								</CosmosText>
							</div>
							<div className={styles.statValue}>
								<CosmosText
									weight="bold"
									size="x-small">
									{track_race_distance}
								</CosmosText>
							</div>
						</div>

						<div className={styles.stat}>
							<div className={styles.statLabel}>
								<CosmosText
									size="x-small"
									weight="bold">
									Circuit Length
								</CosmosText>
							</div>
							<div className={styles.statValue}>
								<CosmosText
									weight="bold"
									size="x-small">
									{track_lap_distance}
								</CosmosText>
							</div>
						</div>

						{track_record_time && (
							<div className={styles.stat}>
								<div className={styles.statLabel}>
									<CosmosText
										size="x-small"
										weight="bold">
										Track Record
									</CosmosText>
								</div>
								<div className={styles.statValue}>
									<CosmosText
										weight="bold"
										size="x-small">
										{track_record_time}
									</CosmosText>
									<CosmosText
										size="xx-small"
										weight="bold"
										className={styles.recordHolder}>
										{trackRecordDriverFormatted}, {track_record_year}
									</CosmosText>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
		// </>
	)
}
